import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=6e077ad4&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=ts"
export * from "./Insurance.vue?vue&type=script&lang=ts"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=6e077ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e077ad4",
  null
  
)

export default component.exports